export const EnglishData = {
  hospitalInformation: 'Hospital / Clinic Information',
  registerno: 'Reg.No.',
  mobileNo: 'Mobile',
  email: 'Email',
  telephoneno: 'Telephone No.',
  gender: 'Gender',
  age: 'Age',
  date: 'Date',
  address: 'Address',
  contactNo: 'Contact No.',
  temperature: 'Temperature',
  bp: 'BP',
  weight: 'Weight',
  pulse: 'Pulse',
  spo2: 'SpO2',
  hemoglobin: 'Hemoglobin',
  serumcreatine: 'Serum Creatinine',
  bloodurea: 'Blood Urea',
  bloodsugar: 'Blood Sugar',
  fasting: 'TL Count',
  fastingPre: 'Pre Meals',
  fastingPost: 'Post Meals',
  diagnosis: 'Diagnosis',
  doctorNotes: 'Doctor notes',
  investigation: 'Investigations',
  procedure: 'Procedures',
  diabetes: 'Diabetic',
  hypertension: 'Hypertension',
  sno: 'S.No.',
  saltname: 'Salt Name',
  drugname: 'Medicine name',
  frequency: 'Frequency',
  unit: 'Unit',
  route: 'Route',
  advice: 'Advice',
  duration: 'Duration',
  symptoms: 'Symptoms',
  diagnosis: 'Diagnosis',
  procedure: 'Procedure',
  allergy: 'Allergies',
  diseases: 'Diseases',
  endDescription:
    'We are creating this prescription as per patient demands. GudMed is only recommending the Generics as per the prescription shared by the patient with their approval. GudMed is not responsible for any medicine dispensing. This transcription is not intended to diagnose, treat, cure, or prevent any disease. By availing this service, you agree to Gudmed’s terms & conditions. To update your profile and other services please login to www.gudmed.in.',

  footercopywrite: 'This is an Electronic Prescription generated by GudMed On ',
  sendButton: 'Send To Patient',
  doctorInfo: 'Doctor Info',
  patientInfo: 'Patient information',
  patientVital: 'Patient vitals',
  bloodSugar: 'Blood Sugar',
  prescriptionInfo: 'Prescription information',
  prescription: 'Prescription',
  prescriptionDate: 'Date',
  history: 'Patient history',
  cardiac: 'Cardiac',
  breakfast: 'Breakfast',
  lunch: 'Lunch',
  tea: 'Tea',
  dinner: 'Dinner',
  gRxendDescription:
    'We are creating this prescription as per patient demands. GudMed is only recommending the Generics as per the prescription shared by the patient with their approval. GudMed is not responsible for any medicine dispensing. This transcription is not intended to diagnose, treat, cure, or prevent any disease. By availing this service, you agree to Gudmed’s terms & conditions. To update your profile and other services please login to www.gudmed.in.',
  // gRxendDescription:'We are creating this prescription as per patient demands. We GudMed is only recommending the Generics as per the prescription shared by the patient with their approval. GudMed is not responsible for any medicine dispensing. GudMed are not intended to diagnose, treat, cure, or prevent any disease. For all terms & conditions please login to gudmed.in/termsandconditions'
  superSpec: 'Orthopadic',
  medtype: 'Medicine type',
  comment: 'Comment',
  originalprescription: 'Original Prescription',
  report: 'Reports',
  genericHeader: 'ALTERNATIVE/GENERIC MEDICINE',
  daycalender: {
    year: 'Years',
    month: 'Months',
    day: 'Days',
  },
  booltruevalue: 'Yes',
  boolfalsevalue: 'No',
  reviewDateTime: 'Next Visit Date & Time',
  symptomsanddiagnosis: 'Symptoms & Diagnosis',
  admissionAdviceDate: 'Admission Advice Date',
  completedlabel: 'Completed',
  rejectlabel: 'Rejected',
  referOriginal: 'Refer to Original Document',
};
